import React from 'react';
import { translate } from 'react-i18next';

import { Form } from 'common/components';

const AssetFormProject = ({
  projects = [],
  errors = {},
  handleValueChange = () => {},
  isSubmitted = false,
  isLoading = false,
  t = () => {},
  values = {},
}) => {
  return (
    <div className="row mt-3 align-items-center bbottom">
      <div className="col-sm-12">
        <h5>
          <b>{t('assets.section.project')}</b>
        </h5>
        <br />
      </div>
      <div className="col-sm-6 col-md-4 col-lg-3">
        <Form.FieldSelect
          error={(isSubmitted && errors._project) || {}}
          isLoading={isLoading}
          name={'project'}
          label={t('assets.fields.project')}
          handleChange={handleValueChange}
          t={t}
          value={values._project && values._project.id}
        >
          {projects &&
            projects.map((project) => (
              <option value={project.id} key={project.id}>
                {project.key} - {project.name}
              </option>
            ))}
        </Form.FieldSelect>
      </div>
      <div className="col-sm-6 col-md-4 col-lg-3">
        <Form.FieldInput
          type="number"
          error={(isSubmitted && errors.projectPrice) || {}}
          name={'projectPrice'}
          label={t('assets.fields.projectPrice')}
          handleChange={handleValueChange}
          t={t}
          value={values.projectPrice}
        />
      </div>
      <div className="col-sm-6 col-md-4 col-lg-3">
        <Form.FieldInput
          error={(isSubmitted && errors.buyOrder) || {}}
          name={'buyOrder'}
          label={t('assets.fields.buyOrder')}
          handleChange={handleValueChange}
          t={t}
          value={values.buyOrder}
        />
      </div>
      <div className="col-sm-6 col-md-4 col-lg-3">
        <Form.FieldInput
          error={(isSubmitted && errors.projectApprovalNumber) || {}}
          name={'projectApprovalNumber'}
          label={t('assets.fields.approvalNumber')}
          handleChange={handleValueChange}
          t={t}
          value={values.projectApprovalNumber}
        />
      </div>
    </div>
  );
};

export default translate()(AssetFormProject);



// WEBPACK FOOTER //
// src/components/assets/form_sections/AssetsFormProject.js